import {
  HiClipboardList,
  HiCheckCircle,
  HiDocumentText,
  HiFolderOpen,
  HiLogin,
  HiLogout,
  HiPlusCircle,
  HiReceiptTax,
} from "react-icons/hi";
import { ADD_BILL, ATTENDANCE, TASK_LIST, BILLS_LIST, CHECK_IN, CHECK_OUT } from "../routes"

const commonCss = "w-8 h-8 md:w-8 md:h-8";

export const MENU_ITEMS = [
  {
    label: "Attendance",
    icon: <HiCheckCircle className={`${commonCss} text-white`} />,
    link: ATTENDANCE,
    color: "bg-blue-600",
  },
  {
    label: "Task",
    icon: <HiClipboardList className={`${commonCss}`} />,
    link: TASK_LIST,
    color: "bg-green-600",
  },
  {
    label: "Bill",
    icon: <HiDocumentText className={`${commonCss}`} />,
    link: BILLS_LIST,
    color: "bg-yellow-600",
  },
  {
    label: "File",
    icon: <HiFolderOpen className={`${commonCss}`} />,
    // link: DRIVE,
    color: "bg-yellow-400",
  },
];

export const QUICK_ACTION_ITEMS = [
  {
    label: "Check-In",
    icon: <HiLogin className={`${commonCss} text-blue-600`} />,
    link: CHECK_IN,
  },
  {
    label: "Check-Out",
    icon: <HiLogout className={`${commonCss} text-red-600`} />,
    link: CHECK_OUT,
  },
  {
    label: "Manage Task",
    icon: <HiPlusCircle className={`${commonCss} text-green-600`} />,
    link: TASK_LIST,
  },
  {
    label: "Add Bill",
    icon: <HiReceiptTax className={`${commonCss} text-yellow-600`} />,
    BillPopUp: true,
    link: ADD_BILL,
  },
];

export const ROLE_COLORS = {
  PROJECT_MANAGER: "bg-blue-100 text-blue-800",
  PROJECT_ENGINEER: "bg-green-100 text-green-800",
  SITE_ENGINEER: "bg-blue-100 text-blue-800",
};

